"use client"
import { useState } from "react"
import { CurrencyContext } from "./use-currency"
import type { CurrencyPreference } from "./utils"

type Props = {
  currency: CurrencyPreference
  children: React.ReactNode
}

export function CurrencyProvider({
  currency: initialCurrency,
  children,
}: Props) {
  const [currency, setCurrency] = useState(initialCurrency)

  function toggleCurrency() {
    switch (currency) {
      case "crypto":
        setCurrency("usd")
        break
      case "usd":
        setCurrency("crypto")
        break
    }
  }

  const value = { currency, setCurrency, toggleCurrency }

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  )
}
